{
  "title": "如何設定競賽組別",
  "description": "建立、編輯與封存競賽組別，供參賽隊伍報名時選擇。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "操作步驟", "完成後", "常見問題"],
  "summary": "完成後，該場競賽有一組可供參賽者選擇的組別，並可視需要限制各組別的隊伍名額。",
  "roleNote": "主辦方管理員",
  "prerequisites": ["已具備該競賽的管理權限"],
  "pathLabel": "主辦方主控台 → 競賽設定 → 組別",
  "steps": [
    {
      "title": "1. 新增組別",
      "description": "填寫組別名稱（必填）與說明（選填），例如「校園自主命題組」「場域指定命題組」。"
    },
    {
      "title": "2. 視需要記錄名額規劃",
      "description": "「名額」欄位可記錄該組別預計容納的隊伍數上限，留空代表不特別記錄；請注意目前系統儲存此數字僅供顯示與規劃參考，並不會在隊伍建立或報名時自動擋下超額報名，若需要控管實際人數上限，仍需由主辦方自行追蹤並視情況手動處理。"
    },
    { "title": "3. 調整顯示順序", "description": "透過排序值調整組別在報名頁面上的顯示先後順序。" },
    {
      "title": "4. 封存不再使用的組別",
      "description": "刪除組別實際上是將狀態改為「已封存」，而非真正從資料庫移除；已有隊伍報名的組別歷史資料不會受影響。"
    }
  ],
  "afterward": [
    "參賽者在報名時可以看到並選擇這些組別",
    "已封存的組別不再出現在報名表的可選清單中，但既有報名資料仍保留原本的組別歸屬"
  ],
  "nextSteps": "組別設定好後，請見「如何建立與發布表單」建立報名表，讓組別成為報名表單的一部分。",
  "faq": [
    {
      "q": "刪除組別會不會連同該組別已有的報名資料一起消失？",
      "a": "不會。刪除實際上只是把組別狀態改為「已封存」，不是真正刪除；已使用該組別報名的既有資料完全不受影響，只是新報名時看不到這個選項。"
    },
    {
      "q": "名額上限被填滿後，系統會自動擋下新的報名嗎？",
      "a": "不會。目前「名額」欄位只用於記錄與顯示，系統不會在隊伍建立或報名時依此數字自動阻擋超額報名；如需實際控管人數，仍須由主辦方自行追蹤報名情況並視需要手動處理。"
    },
    {
      "q": "一定要設定多個組別嗎？",
      "a": "不用，單一組別（甚至不特別區分組別）的競賽也可以正常運作；組別功能是為了讓不同性質的參賽內容（例如自主命題 vs 指定命題）分開評比與統計。"
    }
  ]
}
